/* storybook-check-ignore */
import { css } from '@emotion/react';
import { Button, ButtonProps, Text } from '@opendoor/bricks/core';
import { useReducer } from 'react';
import InfoIcon from '../icons/InfoIcon';
import Modal from '../Modal';

export default function WhyDoIPayLess({
  isSellerOfferExperiment,
  ...props
}: {
  isSellerOfferExperiment: boolean;
} & Omit<ButtonProps, 'analyticsName' | 'aria-label'>) {
  const [isModalOpen, toggleModalOpen] = useReducer((s) => !s, false);
  const whyDoDIPayLessInfo = isSellerOfferExperiment
    ? 'When you buy with Exclusives, you pay less. Since we represent the seller, we can use our commissions to pass savings back.'
    : 'We can save on traditional fees when we can sell a home directly to customers, those savings are reflected in the Exclusive Price.';
  return (
    <>
      <Button
        variant="link"
        analyticsName="cosmos-exclusives-price-section-why-do-i-pay-less-button"
        aria-label={whyDoDIPayLessInfo}
        onClick={toggleModalOpen}
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        gridGap="5px"
        fontSize="s0"
        fontWeight="semibold"
        opacity="0.8"
        style={{ color: '#333333' }}
        lineHeight="s00"
        paddingX="0.125rem"
        css={css`
          border-radius: 5px;
          &:hover {
            opacity: 0.6;
            background-color: var(--colors-neutrals30);
          }
        `}
        {...props}
      >
        <InfoIcon /> Why do I pay less?
      </Button>
      <Modal title="Why do I pay less?" isOpen={isModalOpen} onRequestClose={toggleModalOpen}>
        <Text>{whyDoDIPayLessInfo}</Text>
      </Modal>
    </>
  );
}
